<template>
  <div class="view find-mybooking">

    <h1>{{ $t('my-booking.find') }}</h1>
    <form-input type="text" :label="$t('general.label.booking-number')" icon="number"/>
    <form-input type="email" :label="$t('form.label.guest.email')" icon="email"/>
    <button class="button-search" v-on:click="search">{{ $t('general.label.search') }}</button>

  </div>
</template>

<script>
import FormInput from '@/components/FormInput.vue';

export default {

  data() {
    return {
    }
  },

  methods: {
    search(){
      // TODO: authorize and redirect to My Booking page
    }
  },

  components: {
    FormInput
  }
}
</script>

<style lang="scss">
.view.find-mybooking {
  @include small-page-layout;

  .component.form-input {
    @include form-layout-wide;
  }

  .number .icon { @include font-awesome($fa-var-address-book, light); }
  .email .icon { @include font-awesome($fa-var-envelope, light); }

  .button-search {
    @include button($colorCTA, #fff);
    width: 100%;
  }
}
</style>
